import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { Response } from 'routes/HumanResourcesModule/business/types';
import { HttpError, RQAPICallWithData } from 'store/APIClient';

export type RetrospectiveSalaryMassData = {
    brutTotal: number;
    employerCostsTotal: number;
    salaryMassCurrentYear: number;
    salaryMassPreviousYear: number;
    totalLastMonthCurrentYear: number;
    totalLastMonthPreviousYear: number;
    uniqueAgentsCount: number;
    uniqueAgentsCountWithAmounts: number;
    etp: number;
    etpt: number;
};
type UniqueAgentsCountData = {
    uniqueAgentsCount: number;
};
export type RetrospectivePayComponentSalaryMassData = {
    payComponentSalaryMassCurrentYear: number;
    payComponentSalaryMassPreviousYear: number;
    payComponentTotalLastMonthCurrentYear: number;
    payComponentTotalLastMonthPreviousYear: number;
};
const retrospectiveDataQueryKey = (retrospectiveId: number) =>
    `retrospective_data_${retrospectiveId}`;

export const useGetRetrospectiveSalaryMassData = (retrospectiveId: number) =>
    useQuery({
        queryKey: [retrospectiveDataQueryKey(retrospectiveId), 'salary_mass'],

        queryFn: async () => {
            const response = await RQAPICallWithData<
                Response<RetrospectiveSalaryMassData>
            >({
                endpoint: `human_resources/retrospective/${retrospectiveId}/salary_mass_data`,
            });
            return response.content.data;
        },
    });
export const useGetRetrospectiveUniqueAgentsData = (
    retrospectiveId: number,
): UseQueryResult<UniqueAgentsCountData, HttpError> =>
    useQuery({
        queryKey: [retrospectiveDataQueryKey(retrospectiveId), 'unique_agents'],

        queryFn: async () => {
            const response = await RQAPICallWithData<
                Response<UniqueAgentsCountData>
            >({
                endpoint: `human_resources/retrospective/${retrospectiveId}/unique_agents`,
            });
            return response.content.data;
        },
    });

export type EnveloppesData = {
    totalAstreintes: number;
    totalHs: number;
    totalHc: number;
    hoursHs: number;
    hoursHc: number;
    hoursAstreintes: number;
    absenceCost: number;
    absenceEtp: number;
    seasonalCost: number;
    seasonalEtp: number;
};
export const useGetEnveloppesData = (retrospectiveId: number) =>
    useQuery({
        queryKey: [retrospectiveDataQueryKey(retrospectiveId), 'envelopes'],

        queryFn: async () => {
            const response = await RQAPICallWithData<Response<EnveloppesData>>({
                endpoint: `human_resources/retrospective/${retrospectiveId}/envelopes_data`,
            });
            return response.content.data;
        },
    });

export type GvtDataType = {
    echelonCost: number;
    gradeAdvancementCost: number;
    recruitmentIncidence: number;
    recruitmentDeparture: number;
    gvtTotals: number;
};

export const useGetGvtNoriaData = (retrospectiveId: number) =>
    useQuery({
        queryKey: [
            retrospectiveDataQueryKey(retrospectiveId),
            'gvt_noria_data',
        ],

        queryFn: async () => {
            const response = await RQAPICallWithData<Response<GvtDataType>>({
                endpoint: `human_resources/retrospective/${retrospectiveId}/gvt_noria_data`,
            });
            return response.content.data;
        },
    });

export const useGetRetrospectivePayComponentSalaryMassData = (
    retrospectiveId: number,
) =>
    useQuery({
        queryKey: [
            retrospectiveDataQueryKey(retrospectiveId),
            'pay_component_salary_mass',
        ],

        queryFn: async () => {
            const response = await RQAPICallWithData<
                Response<RetrospectivePayComponentSalaryMassData>
            >({
                endpoint: `human_resources/retrospective/${retrospectiveId}/pay_component_salary_mass_data`,
            });
            return response.content.data;
        },
    });
